import React from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import IconPlus from 'design-system/icons/IconPlus';
import { IconShieldDone } from 'design-system/icons';
import { Button, CardView, rem, Spacer } from 'design-system';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import useColors from 'hooks/useColors';
import { useFraudDetection } from './useFraudDetection';
const strings = {
    fraudDetection: 'Fraud detection',
    desc: 'Let Emma scan the dark web and identify if your personal details have been leaked from other services',
};
const FraudDetectionSetupCard = () => {
    const colors = useColors();
    const handlePress = useFraudDetection(true);
    return (<CardView noMarginTop noMarginBottom withPadding>
      <SettingsItemIcon iconSize={44}>
        <IconShieldDone colorKey="statusPositive"/>
      </SettingsItemIcon>
      <Spacer h={16}/>
      <Text Text-16>{strings.fraudDetection}</Text>
      <Spacer h={4}/>
      <Text TextThin-14 Secondary>
        {strings.desc}
      </Text>
      <Spacer h={16}/>
      <Button brandLight square medium hug onPress={handlePress} containerStyle={styles.setupButton} title="Set up" leftIcon={<IconPlus width={rem(14)} height={rem(14)} color={colors.text.textOnBrand}/>}/>
    </CardView>);
};
export default FraudDetectionSetupCard;
const styles = StyleSheet.create({
    setupButton: {
        alignSelf: 'flex-start',
        paddingHorizontal: rem(24),
    },
});
